import { Table } from '@nimbus-ds/components';
import { InvoicesTaxRulesResponseDto } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import Skeleton from './Skeleton';
import TaxRulesTableBody from './TaxRulesTableBody';

interface TaxRulesTableProps {
  readonly taxRules: InvoicesTaxRulesResponseDto[];
}
function TaxRulesTable({ taxRules }: TaxRulesTableProps) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Cell backgroundColor="neutral-surface" as="th">
            {t('nameTaxRule')}
          </Table.Cell>
          <Table.Cell backgroundColor="neutral-surface" as="th">
            {t('namesStates')}
          </Table.Cell>
        </Table.Row>
      </Table.Head>
      <TaxRulesTableBody taxRules={taxRules} />
    </Table>
  );
}

TaxRulesTable.Skeleton = Skeleton;

export default TaxRulesTable;
